/**
 * <strong>Purpose:</strong> <br>
 * Provides a "watch"-like behavior for the setter of "text".<br>
 * The size setter must also be triggered when the text is changed.<br>
 *
 * <strong>Contract:</strong> <br>
 * This mixin is dependent upon: <br>
 * {@link module:MW/toolstrip/mixins/property/TextMixin}<br>
 * {@link module:mw-form/mixins/property/SizeMixin}<br>
 * {@link module:mw-form/mixins/property/DropDownButtonSizeMixin}<br>
 *
 * @module mw-form/mixins/property/DropDownButtonTextMixin
 *
 * @copyright Copyright 2016 The MathWorks, Inc.
 */

define([
        "dojo/_base/declare",
        "MW/toolstrip/mixins/property/TextMixin",
        "MW/toolstrip/mixins/property/SizeMixin",
        "mw-form/mixins/property/DropDownButtonSizeMixin"
    ],
    function (declare, TextMixin, SizeMixin, DropDownButtonSizeMixin) {

        var DropDownButtonTextMixin = declare(null, {

            _addTextContentClass: function () {
                // No-op: Override from TextMixin.js
            },

            _getTextForDOM: function (text, node) {
                var mainText, lastTextLine, lastNewlineIndex,
                    textNodes = this._getTextNodes();

                if ((node === textNodes.inlineTextElement) || (node === textNodes.lastTextLineElement)) {
                    // Text has a newline character
                    if ((lastNewlineIndex = text.lastIndexOf("\n")) > -1) {
                        // Split text at last newline if arrow mode is "inline" and
                        // set the text contents of the lastNewLine node to be the
                        // text following the last newline character.
                        mainText = text.substring(0, lastNewlineIndex);
                        lastTextLine = text.substring(lastNewlineIndex+1, text.length);
                    } else { // Text does not have a newline character
                        mainText = text;
                        lastTextLine = ""; // Adds mwEmptyNode class to node
                    }

                    if (node === textNodes.inlineTextElement) {
                        return mainText;
                    } else if (node === textNodes.lastTextLineElement) {
                        return lastTextLine;
                    }
                } else {
                    return text;
                }
            },

            _placeTextInNode: function (text) {
                var textNodes = this._getTextNodes();

                textNodes.forEach(function (node) {
                    var textForDOM = this._getTextForDOM(text, node);
                    this._updateDataTextContent(textForDOM, node, true);
                    if ((node === this.lastTextLine) && (!textForDOM)) {
                        this.lastTextLineNode.classList.add("mwNoText");
                    } else if (node === this.lastTextLine) {
                        this.lastTextLineNode.classList.remove("mwNoText");
                    }
                }.bind(this));
            },

            _getTextNodes: function () {
                var textNodes = [this.textLine, this.inlineTextLine, this.lastTextLine];
                textNodes.textElement = textNodes[0];
                textNodes.inlineTextElement = textNodes[1];
                textNodes.lastTextLineElement = textNodes[2];
                return textNodes;
            }

        });

        DropDownButtonTextMixin._dependencies = [
            {mixin: TextMixin, orderDependent: true},
            {mixin: SizeMixin, orderDependent: false},
            {mixin: DropDownButtonSizeMixin, orderDependent: false}
        ];

        return DropDownButtonTextMixin;
    });
